import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const BUYERS = [{
  name: 'Carmen López',
  city: 'Ciudad de México'
}, {
  name: 'Rosa Martínez',
  city: 'Bogotá'
}, {
  name: 'Elena García',
  city: 'Lima'
}, {
  name: 'Patricia Sánchez',
  city: 'Buenos Aires'
}, {
  name: 'Lucía Fernández',
  city: 'Santiago'
}, {
  name: 'María Rodríguez',
  city: 'Guadalajara'
}, {
  name: 'Ana Herrera',
  city: 'Medellín'
}, {
  name: 'Sofía Ramírez',
  city: 'Quito'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 30000);
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 10000) + 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-267">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3" data-id="element-268">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-269">
            <ShoppingCartIcon className="w-5 h-5 text-green-600" data-id="element-270" />
          </div>
          <div data-id="element-271">
            <p className="text-sm text-gray-800 leading-tight" data-id="element-272">
              <span className="font-bold" data-id="element-273">{currentBuyer.name}</span> de{' '}
              <span className="font-semibold" data-id="element-274">{currentBuyer.city}</span> acaba
              de adquirir{' '}
              <span className="font-bold text-green-700" data-id="element-275">
                LAS 50 POMADAS MEDICINALES™
              </span>
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-276">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}